import React from "react";
import "./index.css";
import { Link, useNavigate } from "react-router-dom";
import ButtonForAll from "../../components/ButtonForALL";
import TopPageImage from "../../components/toppageimage";

const Empty = ({ emptyorderlist }) => {
  const navigate = useNavigate();

  const handleButtonClick = () => {
    navigate("/product");
  };

  return (
    <>
    
          <div
            className="emptycon"
            style={{
              height: "70vh",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <div className="data">
              <h3>No Card Items Found</h3>
              <div
                className="btnWishlist"
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <Link to={"/product"} style={{ textDecoration: "none" }}>
                  <ButtonForAll
                    name="CONTINUE SHOPING"
                    className="Wishlistbtn"
                  ></ButtonForAll>
                </Link>
              </div>
            </div>
          </div>
        
    </>
  );
};

export default Empty;
